'use client';

import React, { forwardRef } from 'react';
import { useHeader } from '@/contexts/HeaderContext';

interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const SectionWrapper = forwardRef<HTMLDivElement, SectionWrapperProps>(
  ({ children, className = '', style }, ref) => {
    const { isHeaderVisible, hideHeader } = useHeader();

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
      // Only hide header if it's currently visible
      // Don't interfere with other interactions when header is hidden
      if (isHeaderVisible) {
        // Check if the click target is an interactive element (button, link, input, etc.)
        const target = e.target as HTMLElement;
        const isInteractive = 
          target.tagName === 'BUTTON' ||
          target.tagName === 'A' ||
          target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.closest('button') ||
          target.closest('a') ||
          target.closest('input') ||
          target.closest('textarea') ||
          target.closest('select') ||
          target.closest('[role="button"]') ||
          target.closest('[onclick]');

        // Only hide header if clicking on non-interactive elements
        if (!isInteractive) {
          hideHeader();
        }
      }
    };

    return (
      <div
        ref={ref}
        className={className}
        style={style}
        onClick={isHeaderVisible ? handleClick : undefined}
      >
        {children}
      </div>
    );
  }
);

SectionWrapper.displayName = 'SectionWrapper';

export default SectionWrapper;

